'use client';
import styled from 'styled-components';
import { colors } from '@/styles';

export const ClientWrapper = styled.div`
  flex: 1;
  height: 100%;
  /* min-height: 100%; */
  display: flex;
  flex-direction: column;
  /* border-top: 1px solid ${colors.secondary.lightGray3}; */
  min-width: 100%;
  /* border: 1px solid lime; */
`;

export const EditableStatus = styled.div`
  width: 100%;
  text-align: center;
  /* border: 1px solid red; */
  padding: 10px;
  font-weight: 600;
  border-top: 1px solid ${colors.secondary.lightGray3};
  background-color: ${colors.semantic.notice.light};
  color: ${colors.semantic.notice.dark};
`;

export const DataFrameTable = styled.div`
  position: relative;
  min-height: 300px;
  width: 100%;
  flex: 1;
  border-top: 1px solid ${colors.secondary.lightGray3};

  div[role='grid'] {
    border: none;
    /* margin-bottom: 10px; */
    border-bottom: 1px solid ${colors.secondary.lightGray3};
  }
`;

export const DataFrameTableLoadingOverlay = styled.div`
  position: absolute;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 80px;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  font-weight: bold;
  background: rgba(255, 255, 255, 0.75);
`;
